export const PROFILE_TAB_KEYS = {
  USER_INFO: 'userInfo',
  CHANGE_PASSWORD: 'changePassword',
  PACKAGE_MANAGEMENT: 'packageManagement',
}
